import { ApiError } from 'app/api/exception/ApiError';
import { CreditCardOrderRejectedException } from 'app/api/exception/CreditCardOrderRejectedException';
import { EmptyReferenceException } from 'app/api/exception/EmptyReferenceException';
import { NotFoundException } from 'app/api/exception/NotFoundException';
import { OtpValidationException } from 'app/api/exception/OtpValidationException';
import { UnauthorizedException } from 'app/api/exception/UnauthorizedException';
import { ValidationException } from 'app/api/exception/ValidationException';
import { anyExceptionExceptListed } from 'app/logic/pages/error/defaultExceptionHandler';

const LOGGER_IGNORED_EXCEPTIONS = [
    ApiError.NAME,
    CreditCardOrderRejectedException.NAME,
    EmptyReferenceException.NAME,
    NotFoundException.NAME,
    OtpValidationException.NAME,
    UnauthorizedException.NAME,
    ValidationException.NAME,
];

/**
 * Добавить обработчик ошибок, логирующий событие на сервер
 * @param pageName
 * @param method
 */
export const exceptionLogger = (pageName: string, method: string) => {
    const logger = (window as any).getLogger();

    return anyExceptionExceptListed(LOGGER_IGNORED_EXCEPTIONS, (error: Error) => {
        logger.error(
            `Error occurred on ${pageName} at ${method}: ${error?.message}`,
            error,
        );
        throw error;
    });
};
